import { cubicBezier } from './cubic-bezier.mjs';

const easeIn = /*@__PURE__*/ cubicBezier(0.42, 0, 1, 1);
const easeOut = /*@__PURE__*/ cubicBezier(0, 0, 0.58, 1);
const easeInOut = /*@__PURE__*/ cubicBezier(0.42, 0, 0.58, 1);

export { easeIn, easeInOut, easeOut };
//# sourceMappingURL=ease.mjs.map
